module.exports = "/work-site/img/control_back.d100010c.png";